import React from "react";
import { toast, Card } from "@jsq/ds/core";
import { Form } from "@jsq/ds/forms";
import { Column, ColumnContainer } from "@jsq/ds/layouts";
import { PayeeCreatePaymentPrefWorkflow } from "../../../../PaymentPrefConsolidated/Workflows/PayeePaymentPrefWorkflow";
import { DocumentTracker } from "../../../components/DocumentTracker";
import { FormStepFooter } from "../../../components/FormStepFooter";
import { PayeeStepActionTypes } from "../../../Context/constants";
import {
  useBasePayeeReducerContext,
  usePayeeWorkflowDispatchContext,
} from "../../../Context/PayeeContext";
import {
  paymentPrefInstructionsStyles,
  stepColumnContainerStyles,
  stepContainerStyles,
} from "../../../styles_vanilla.css";

export const VendorPaymentInstructionsStep: React.FC = () => {
  const stepDispatch = usePayeeWorkflowDispatchContext();
  const { invoices, paymentPref, arenaId } = useBasePayeeReducerContext();

  if (!arenaId) {
    toast.error("Arena ID is required");
    return null;
  }

  const onSuccess = () => {
    stepDispatch({ type: PayeeStepActionTypes.INCREMENT_STEP });
  };

  const onExit = () => {
    stepDispatch({ type: PayeeStepActionTypes.DECREMENT_STEP });
  };

  return (
    <div className={stepContainerStyles}>
      <ColumnContainer className={stepColumnContainerStyles}>
        <Column size={"fluid"}>
          <DocumentTracker
            documentName={invoices?.[0].name ?? ""}
            documentUrl={invoices?.[0].localUrl ?? ""}
          />
        </Column>
        <Column size={"fluid"} className={paymentPrefInstructionsStyles}>
          <Card>
            <PayeeCreatePaymentPrefWorkflow
              paymentPref={paymentPref}
              arenaId={arenaId}
              onExit={onExit}
              onSuccess={onSuccess}
            />
          </Card>
        </Column>
      </ColumnContainer>
      <Form
        initialValues={{}}
        onSubmit={() => {
          stepDispatch({ type: PayeeStepActionTypes.INCREMENT_STEP });
        }}
      >
        <FormStepFooter submitDisabled />
      </Form>
    </div>
  );
};

export default VendorPaymentInstructionsStep;
